import { contentPreferenceRevision, subscribeContentPreferences } from '../utils/contentPreferences';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import './TranscriptSection.css';
import CallHistoryItem from './CallHistoryItem';
import CallDetailDrawer from './CallDetailDrawer';
import { Button, EmptyState, Skeleton, Surface } from './ui/Primitives';

function TranscriptSection() {
  const loadSequence = useRef(0);
  const [transcripts, setTranscripts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCallId, setSelectedCallId] = useState(null);

  const loadCalls = useCallback(() => {
    const sequence = ++loadSequence.current;
    const revision = contentPreferenceRevision();
    const token = localStorage.getItem('jwt_authorization');
    const current = () => sequence === loadSequence.current && revision === contentPreferenceRevision() && token === localStorage.getItem('jwt_authorization');
    return axios.get(`${process.env.REACT_APP_BACKEND_HOST}/v2/calls`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}` },
      params: { scope: 'all', limit: 5, offset: 0 },
    }).then((response) => { if (current()) setTranscripts(response.data.calls || []); })
      .catch(() => { if (current()) setTranscripts([]); })
      .finally(() => { if (current()) setIsLoading(false); });
  }, []);

  useEffect(() => {
    loadCalls();
    const timer = window.setInterval(loadCalls, 5000);
    const unsubscribe = subscribeContentPreferences(() => { loadSequence.current += 1; setTranscripts([]); setIsLoading(true); loadCalls(); });
    return () => { loadSequence.current += 1; unsubscribe(); window.clearInterval(timer); };
  }, [loadCalls]);

  return (
    <><Surface className="transcript-info-section" padding="none">
      <div className="transcript-info-heading">
        <div><span className="say-eyebrow">Recent conversations</span></div>
        <Button to="/calls" size="sm" variant="quiet">View all calls</Button>
      </div>
      <div data-say-id="recent-transcripts" className="transcript-list">
        {isLoading ? <div className="transcript-loading"><Skeleton height={56} /><Skeleton height={56} /><Skeleton height={56} /></div> : transcripts.length === 0 ? (
          <EmptyState title="No calls yet" description="Once Sayable answers a call, its summary and transcript will appear here." />
        ) : transcripts.map(call => <CallHistoryItem key={call.id} call={call} onOpen={item => setSelectedCallId(item.id)} />)}
      </div>
    </Surface>
    {selectedCallId ? <CallDetailDrawer key={selectedCallId} callId={selectedCallId} onClose={() => setSelectedCallId(null)} onHandlingChange={loadCalls} onRead={loadCalls} /> : null}</>
  );
}

export default TranscriptSection;
